module.exports = __webpack_public_path__ + "img/blockly.2f85acbc.png";